import { render, staticRenderFns } from "./EntityTabLinks.vue?vue&type=template&id=747d8046&"
import script from "./EntityTabLinks.vue?vue&type=script&lang=js&"
export * from "./EntityTabLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports